import { createStyles, makeStyles } from '@material-ui/core/styles';
import { colorsPalette } from '../../../../theme';

const useStyles = makeStyles(() =>
  createStyles({
    helperText: {
      fontSize: 14,
      lineHeight: 1.2,
      fontWeight: 'normal',
      color: colorsPalette.violet,
      '& > a': {
        color: colorsPalette.violet,
      },
    },
  }),
);
export default useStyles;
